module.exports = __webpack_public_path__ + "static/media/star.bbb7ece8.svg";